(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('AddressableTVTrackpointModalController', AddressableTVTrackpointModal);

    AddressableTVTrackpointModal.$inject = [
      '$element',
      'close',
      'selectedTrackpoints',
      'campaign',
      'onSave'
    ];

    function AddressableTVTrackpointModal(
      $element,
      close,
      selectedTrackpoints,
      campaign,
      onSave,
    ) {
        var vm = this;

        vm.isSingle = selectedTrackpoints.length === 1;
        vm.initialValue = getInitialValue();
        vm.trackpoint = vm.isSingle && selectedTrackpoints[0].name;

        vm.options = [{
          value: 'auto',
          label: 'Auto (recommended)',
          description: 'Let AudienceReport determine wether or not to apply the Addressable TV measurement for this tracking point.'
        }, {
          value: 'on',
          label: 'On',
          description: 'Always apply the Addressable TV measurement on this tracking point (don’t do this unless you know what you’re doing).'
        }, {
          value: 'off',
          label: 'Off',
          description: 'Never apply the Addressable TV measurement on this tracking point.'
        }];


        function getInitialValue() {
          const firstTrackpointFeatureTV = selectedTrackpoints[0].properties.featureTV;
          const equal = selectedTrackpoints.every(item =>
            item.properties.featureTV === firstTrackpointFeatureTV);

          if (vm.isSingle || equal) {
            return firstTrackpointFeatureTV;
          }

          return false;
        }

        function closeModal() {
          $element.modal('hide');
          close(null, 500);
        }

        vm.onSelect = function(value) {
          vm.selectedValue = value;
        };

        vm.save = function() {
          angular.forEach(selectedTrackpoints, trackpoint => {
            angular.forEach(campaign.trackpoints, tp => {
              if (tp.tailcode === trackpoint.tailcode) {
                tp.properties.featureTV = (vm.selectedValue || vm.initialValue);
              }
            });
          });

          onSave();
          closeModal();
        };

        vm.close = function () {
          var shouldClose = !vm.selectedValue || confirm("You have unsaved changes. Close without saving?");
          if (shouldClose) {
            closeModal();
          }
        };

    }
})();
